import { render, staticRenderFns } from "./ScrollArea.vue?vue&type=template&id=21873172&scoped=true&"
import script from "./ScrollArea.vue?vue&type=script&lang=js&"
export * from "./ScrollArea.vue?vue&type=script&lang=js&"
import style0 from "./ScrollArea.vue?vue&type=style&index=0&id=21873172&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21873172",
  null
  
)

export default component.exports